import { useQuery } from '@tanstack/react-query';
import { message } from 'antd';
import { apiGet } from 'helpers/ApiHelper';
import { getTranslatedString } from 'helpers/i18n';

export const useAncillaryItemTypes = (propertyId) =>
  useQuery({
    queryKey: ['properties', propertyId],
    queryFn: () =>
      apiGet(
        `/landlords/application_management/properties/${propertyId}/ancillary_item_types`
      ).then((response) => {
        return [...response.ancillary_item_types];
      }),
    onError: () => message.error(getTranslatedString('unknownError')),
  });
